<template>
 <div class="box">
  <div>
    起始
   <el-input v-model="postForm.origin" style="width: 200px;"></el-input>
   目标
   <el-input v-model="postForm.destination" style="width: 200px;"></el-input>
   <el-button type="info" @click="clickpost">提交</el-button>
  </div>
  <div id="container" style="width:100%; height:600px"></div>
 </div>
</template>

<script>
import AMap from 'AMap' // 引入高德地图
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      postForm: {
        origin: '119.895129,31.808226',
        destination: '119.979967,31.806996'
      },
      map: null,
      zoom: 20
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.map = new AMap.Map('container', {
        center: [119.89486, 31.808267],
        resizeEnable: true,
        zoom: this.zoom
      })
    },
    clickpost () {
      this.apiAmapDirectionWalking()
    },
    drawCircle (lng, lat, stepindex, action) {
      var fillColor = 'red'
      if (stepindex % 2 === 1) {
        fillColor = 'green'
      }

      var circle = new AMap.Circle({
        center: new AMap.LngLat(lng, lat), // 圆心位置
        radius: 2, // 圆半径
        fillColor: fillColor, // 圆形填充颜色
        strokeColor: '#fff', // 描边颜色
        strokeWeight: 1 // 描边宽度
      })

      this.map.add(circle)
    },
    drawMarker (lng, lat, action) {
      if (action.length > 0) {
        var marker = new AMap.Marker({
          position: new AMap.LngLat(lng, lat),
          icon: 'https://appfile-1256233047.cos.ap-shanghai.myqcloud.com/image/greens.png',
          anchor: 'center', // 设置锚点
          offset: new AMap.Pixel(0, 0)
        })
        marker.setMap(this.map)

        marker.setLabel({
          offset: new AMap.Pixel(0, 0), // 设置文本标注偏移量
          content: "<div class='info'>" + action + '</div>', // 设置文本标注内容
          anchor: 'middle-left', // 设置锚点
          direction: 'right' // 设置文本标注方位
        })
      }
    },
    apiAmapDirectionWalking: function () {
      var that = this
      var data = {
        origin: that.postForm.origin,
        destination: that.postForm.destination
      }
      axios.post(Vue.prototype.global.Url_AmapDirectionWalking, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === '200') {
            that.map.clearMap()
            var path = []

            response.data.AmapStep.filter((item, i) => {
              if (i === 0) {
                that.map.setZoom(that.zoom)
                that.map.setCenter(new AMap.LngLat(item.lng, item.lat))
              }
              that.drawCircle(item.lng, item.lat, item.stepindex, item.action)
              that.drawMarker(item.lng, item.lat, item.action)
              path.push(new AMap.LngLat(item.lng, item.lat))
            })

            // 创建折线实例
            var polyline = new AMap.Polyline({
              path: path,
              borderWeight: 2, // 线条宽度，默认为 1
              strokeColor: 'red', // 线条颜色
              lineJoin: 'round' // 折线拐点连接处样式
            })

            // 将折线添加至地图实例
            that.map.add(polyline)
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>
